<template>
  <div
    class="modal fade"
    id="profiles-columns"
    tabindex="-1"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>

          <div class="text-center">
            <h4 class="mb-2">Profiles Columns</h4>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="Profile"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-brand-databricks"></i>
                      <span class="custom-option-title"> Name </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="Profile"
                      checked
                    />
                  </label>
                </div>
              </div>
              <div class="col-xxl-3 col-md-4 col-6  mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="firstname"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-playstation-circle"></i>
                      <span class="custom-option-title"> Status </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="firstname"
                      checked
                    />
                  </label>
                </div>
              </div>
              <div class="col-xxl-3 col-md-4 col-6  mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="lastname"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-cloud"></i>
                      <span class="custom-option-title"> Service </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="lastname"
                    />
                  </label>
                </div>
              </div>
              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="username"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-list-letters"></i>
                      <span class="custom-option-title"> Type </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="username"
                    />
                  </label>
                </div>
              </div>
              <div class="col-xxl-3 col-md-4 col-6  mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="Password"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-tags"></i>
                      <span class="custom-option-title"> Price </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="Password"
                    />
                  </label>
                </div>
              </div>
              <div class="col-xxl-3 col-md-4 col-6  mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="mobileNumber"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-brand-speedtest"></i>
                      <span class="custom-option-title"> Speed Limit </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="mobileNumber"
                    />
                  </label>
                </div>
              </div>
              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="lineNumber"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-calendar-stats"></i>
                      <span class="custom-option-title"> Expiration </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="lineNumber"
                    />
                  </label>
                </div>
              </div>
              <div class="col-xxl-3 col-md-4 col-6  mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="portNumber"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-package"></i>
                      <span class="custom-option-title"> Quota </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="portNumber"
                    />
                  </label>
                </div>
              </div>
              <div class="col-xxl-3 col-md-4 col-6  mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="Notes"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-packages"></i>
                      <span class="custom-option-title">
                        Mikrotik IP Pool
                      </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="Notes"
                    />
                  </label>
                </div>
              </div>
              <div class="col-xxl-3 col-md-4 col-6  mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="ip"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-users"></i>
                      <span class="custom-option-title"> Total Accounts </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="ip"
                    />
                  </label>
                </div>
              </div>
              <div class="col-xxl-3 col-md-4 col-6  mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="expirationDate"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-user-check"></i>
                      <span class="custom-option-title"> Online Accounts </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="expirationDate"
                    />
                  </label>
                </div>
              </div>
              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="ASessions"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-network"></i>
                      <span class="custom-option-title"> Allowed Nases </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="ASessions"
                    />
                  </label>
                </div>
              </div>
              <div class="col-xxl-3 col-md-4 col-6  mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="ARenew"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-user-shield"></i>
                      <span class="custom-option-title"> Allowed Admins </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="ARenew"
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "columnsProfiles",
};
</script>
